export const LanguageKey: string = 'language';
export const ThemeKey: string = 'theme';
export const CursorVisibilityKey: string = 'cursor-visibility';
